import { Card, CardActionArea, CardContent, CardMedia, Stack, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { Fragment, ReactNode } from 'react';

/**
 * Composant pour les boutons de service de la page d'accueil.
 * @param props
 * @constructor
 */
export default function Service(props: {
    title: string;
    description?: ReactNode;
    img: string;
    href: string;
    styleName?: string;
}) {
    const online = 'online-process';
    const homeService = 'home-service';
    const home = 'home';
    return (
        <Stack spacing={2}>
            <Card
                sx={{
                    margin: '10px',
                    textAlign: 'center',
                    ...(online === props.styleName && { height: 400 }),
                    ...(homeService === props.styleName && { height: 400 }),
                }}
            >
                <CardActionArea
                    component={Link}
                    to={props.href}
                    sx={{
                        height: 'inherit',
                        display: 'flex',
                        flexFlow: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <CardContent
                        sx={{
                            padding: '5px',
                            paddingBottom: '5px',
                        }}
                    >
                        <Typography
                            variant="h5"
                            sx={{
                                textTransform: 'none',
                                marginTop: '10px',
                                marginBottom: '10px',
                                fontWeight: 'inherit',
                                fontSize: '1.5',
                                ...((online === props.styleName || home === props.styleName) &&
                                    props.title.length < 25 && { fontSize: '1.7em' }),
                            }}
                        >
                            {props.title}
                        </Typography>
                        {props.description && <Fragment>{props.description}</Fragment>}
                    </CardContent>
                    <CardMedia
                        component="img"
                        src={props.img}
                        alt="image service"
                        sx={{
                            ...(online === props.styleName && { width: '65%' }),
                            '&:hover': { transform: 'scale(1.1, 1.1)' },
                        }}
                    />
                </CardActionArea>
            </Card>
        </Stack>
    );
}
